export enum DataPicker {
  AM = 'yPSK',
  PM = 'a5h2',
}
